module.exports = __webpack_public_path__ + "6e89dd5522cfc6c4f29b66c9a7da743c.MP3";